import { render, staticRenderFns } from "./samplePo.vue?vue&type=template&id=043d51d0&scoped=true"
import script from "./samplePo.vue?vue&type=script&lang=js"
export * from "./samplePo.vue?vue&type=script&lang=js"
import style0 from "./samplePo.vue?vue&type=style&index=0&id=043d51d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043d51d0",
  null
  
)

export default component.exports